import { AnyAction } from 'redux';
import { clientsConstants } from '../Constants';
import { clientsServices } from '../Services';

export const clientsActions = {
    clearData,
    clientDetail,
    addClientDetail,
    removeE9Status,
    getDevicesList,
    addDevicesList,
    SearchSyncSetting,
    deleteDevice,
    deleteUnassignNumber,
    getVerifiedNumbers,
    SearchAllAddonsforUser,
    getBlockedNumbers,
    createBlockedNumbers,
    updateBlockedNumbers,
    deleteBlockedNumbers,
    getTickets,
    getVoiceMailList,
    voiceMailCreate,
    deleteVoiceMail,
    getAddressBookList,
    getCallLogs,
    getSmsLogs,
    getOutboundProviders,
    getSipcredentials,
    getUsage,
    getAccountLogs,
    clinetUpdateDevice,
    addAddressList,
    deleteVerifiedNumber,
    addVerifyNumberList,
    getSubscriptionAddons,
    addSubscriptionAddons,
    removeSubscriptionAddons,
    getRecomendedAddons,
    getActivityLogs,
    getAppDebugLogs,
    getPaymentTransaction,
    updateEdetails,
    updatePhoneNumber,
    updateefonclient,
    getBusinesSubscriptonAddons,
    getBusinessRecomendedAddons,
    addBusinessSubscriptionAddons,
    deleteBusineSubscription
};

function clearData() {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.CLEAR_CLIENT_DATA,
            data: null
        }));
    };
};
// business addons

function getBusinesSubscriptonAddons(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.BUSINESS_SUBSCRIPTION_ADDONS_REQUEST,
            data: null
        }));
        clientsServices.getBusinesSubscriptonAddons(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.BUSINESS_SUBSCRIPTION_ADDONS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.BUSINESS_SUBSCRIPTION_ADDONS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.BUSINESS_SUBSCRIPTION_ADDONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getBusinessRecomendedAddons(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.BUSINESS_RECOMENDED_ADDONS_REQUEST,
            data: null
        }));
        clientsServices.getBusinessRecomendedAddons(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.BUSINESS_RECOMENDED_ADDONS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.BUSINESS_RECOMENDED_ADDONS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.BUSINESS_RECOMENDED_ADDONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function addBusinessSubscriptionAddons(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.ADD_BUSINESS_SUBSCRIPTION_ADDONS_REQUEST,
            data: null
        }));
        clientsServices.addBusinessSubscriptionAddons(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADD_BUSINESS_SUBSCRIPTION_ADDONS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADD_BUSINESS_SUBSCRIPTION_ADDONS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ADD_BUSINESS_SUBSCRIPTION_ADDONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function deleteBusineSubscription(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.DELETE_BUSINESS_SUBSCRIPTION_ADDONS_REQUEST,
            data: null
        }));
        clientsServices.deleteBusineSubscription(data)
            .then(
                response  => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DELETE_BUSINESS_SUBSCRIPTION_ADDONS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DELETE_BUSINESS_SUBSCRIPTION_ADDONS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.DELETE_BUSINESS_SUBSCRIPTION_ADDONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

//end


function getSubscriptionAddons(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.SUBSCRIPTION_ADDONS_REQUEST,
            data: null
        }));
        clientsServices.getSubscriptionAddons(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.SUBSCRIPTION_ADDONS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.SUBSCRIPTION_ADDONS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.SUBSCRIPTION_ADDONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function updateefonclient(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.UPDATE_EFONECLIENT_DETAIL_REQUEST,
            data: null
        }));
        clientsServices.updateefonclient(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.UPDATE_EFONECLIENT_DETAIL_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.UPDATE_EFONECLIENT_DETAIL_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.UPDATE_EFONECLIENT_DETAIL_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function updatePhoneNumber(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.UPDATE_PHONENUMBER_DETAIL_REQUEST,
            data: null
        }));
        clientsServices.updatePhoneNumber(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.UPDATE_PHONENUMBER_DETAIL_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.UPDATE_PHONENUMBER_DETAIL_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.UPDATE_PHONENUMBER_DETAIL_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function addSubscriptionAddons(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.ADD_SUBSCRIPTION_ADDONS_REQUEST,
            data: null
        }));
        clientsServices.addSubscriptionAddons(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADD_SUBSCRIPTION_ADDONS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADD_SUBSCRIPTION_ADDONS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ADD_SUBSCRIPTION_ADDONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}
function SearchAllAddonsforUser(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.GET_SEARCH_ADDON_REQUEST,
            data: null
        }));
        clientsServices.SearchAllAddonsforUser(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.GET_SEARCH_ADDON_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.GET_SEARCH_ADDON_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ADD_SUBSCRIPTION_ADDONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function SearchSyncSetting(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.GET_SEARCH_SYNC_SETTING_REQUEST,
            data: null
        }));
        clientsServices.SearchSyncSetting(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.GET_SEARCH_SYNC_SETTING_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.GET_SEARCH_SYNC_SETTING_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ADD_SUBSCRIPTION_ADDONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function removeSubscriptionAddons(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.REMOVE_SUBSCRIPTION_ADDONS_REQUEST,
            data: null
        }));
        clientsServices.removeSubscriptionAddons(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.REMOVE_SUBSCRIPTION_ADDONS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.REMOVE_SUBSCRIPTION_ADDONS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.REMOVE_SUBSCRIPTION_ADDONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function removeE9Status(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.REMOVE_EDETAIL_DETAIL_REQUEST,
            data: null
        }));
        clientsServices.removeE9Status(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.REMOVE_EDETAIL_DETAIL_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.REMOVE_EDETAIL_DETAIL_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.REMOVE_EDETAIL_DETAIL_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getRecomendedAddons(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.RECOMENDED_ADDONS_REQUEST,
            data: null
        }));
        clientsServices.getRecomendedAddons(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.RECOMENDED_ADDONS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.RECOMENDED_ADDONS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.RECOMENDED_ADDONS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function clientDetail(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.CLIENT_DETAIL_REQUEST,
            data: null
        }));
        clientsServices.clientDetail(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.CLIENT_DETAIL_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.CLIENT_DETAIL_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.CLIENT_DETAIL_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function addClientDetail(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.ADD_CLIENT_DETAIL_REQUEST,
            data: null
        }));
        clientsServices.addClientDetail(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADD_CLIENT_DETAIL_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADD_CLIENT_DETAIL_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ADD_CLIENT_DETAIL_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function updateEdetails(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.UPDATE_EDETAIL_DETAIL_REQUEST,
            data: null
        }));
        clientsServices.updateEdetails(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.UPDATE_EDETAIL_DETAIL_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.UPDATE_EDETAIL_DETAIL_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.UPDATE_EDETAIL_DETAIL_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function getDevicesList(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.DEVICES_LIST_REQUEST,
            data: null
        }));
        clientsServices.getDevicesList(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DEVICES_LIST_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DEVICES_LIST_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.DEVICES_LIST_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function addDevicesList(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.ADD_DEVICES_REQUEST,
            data: null
        }));
        clientsServices.addDevicesList(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADD_DEVICES_SUCCESS,
                            data: response
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADD_DEVICES_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ADD_DEVICES_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function addAddressList(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.ADD_DEVICES_REQUEST,
            data: null
        }));
        clientsServices.addAddressList(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADDRESS_BOOK_ADD_SUCCESS,
                            data: response
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADDRESS_BOOK_ADD_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ADDRESS_BOOK_ADD_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function deleteUnassignNumber(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.REMOVE_UNASSIGN_NUMBER_REQUEST,
            data: null
        }));
        clientsServices.deleteUnassignNumber(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.REMOVE_UNASSIGN_NUMBER_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.REMOVE_UNASSIGN_NUMBER_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.REMOVE_UNASSIGN_NUMBER_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function deleteDevice(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.DELETE_DEVICE_REQUEST,
            data: null
        }));
        clientsServices.deleteDevice(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DELETE_DEVICE_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DELETE_DEVICE_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.DELETE_DEVICE_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function clinetUpdateDevice(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.CLINET_UPDATE_DEVICE_REQUEST,
            data: null
        }));
        clientsServices.clinetUpdateDevice(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.CLINET_UPDATE_DEVICE_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.CLINET_UPDATE_DEVICE_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.CLINET_UPDATE_DEVICE_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function getVerifiedNumbers(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.VERIFIED_NUMBERS_REQUEST,
            data: null
        }));
        clientsServices.getVerifiedNumbers(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.VERIFIED_NUMBERS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.VERIFIED_NUMBERS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.VERIFIED_NUMBERS_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function deleteVerifiedNumber(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.DELETE_VERIFIED_NUMBERS_REQUEST,
            data: null
        }));
        clientsServices.deleteVerifiedNumber(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DELETE_VERIFIED_NUMBERS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DELETE_VERIFIED_NUMBERS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.DELETE_VERIFIED_NUMBERS_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function addVerifyNumberList(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.ADD_VERIFIED_NUMBERS_REQUEST,
            data: null
        }));
        clientsServices.addVerifiedNumber(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADD_VERIFIED_NUMBERS_SUCCESS,
                            data: response
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADD_VERIFIED_NUMBERS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ADD_VERIFIED_NUMBERS_FAILURE,
                        data: error.response.data.message
                    }));
                }
            );
    };
}

function createBlockedNumbers(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.CREATE_BLOCKED_NUMBER_REQUEST,
            data: null
        }));
        clientsServices.createBlockedNumbers(data)
            .then(
                (response: any) => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.CREATE_BLOCKED_NUMBER_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.CREATE_BLOCKED_NUMBER_FAILURE,
                            data: response.message
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.CREATE_BLOCKED_NUMBER_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function updateBlockedNumbers(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.UPDATE_BLOCKED_NUMBER_REQUEST,
            data: null
        }));
        clientsServices.updateBlockedNumbers(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.UPDATE_BLOCKED_NUMBER_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.UPDATE_BLOCKED_NUMBER_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.UPDATE_BLOCKED_NUMBER_FAILURE,
                        data: error
                    }));
                }
            );
    };
}

function deleteBlockedNumbers(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.DELETE_BLOCKED_NUMBER_REQUEST,
            data: null
        }));
        clientsServices.deleteBlockedNumbers(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DELETE_BLOCKED_NUMBER_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DELETE_BLOCKED_NUMBER_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.DELETE_BLOCKED_NUMBER_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getBlockedNumbers(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.BLOCKED_NUMBERS_REQUEST,
            data: null
        }));
        clientsServices.getBlockedNumbers(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.BLOCKED_NUMBERS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.BLOCKED_NUMBERS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.BLOCKED_NUMBERS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getTickets(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.TICKETS_REQUEST,
            data: null
        }));
        clientsServices.getTickets(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.TICKETS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.TICKETS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.TICKETS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getVoiceMailList(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.VOICE_MAIL_LIST_REQUEST,
            data: null
        }));
        clientsServices.getVoiceMailList(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.VOICE_MAIL_LIST_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.VOICE_MAIL_LIST_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.VOICE_MAIL_LIST_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function voiceMailCreate(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.VOICE_MAIL_CREATE_REQUEST,
            data: null
        }));
        clientsServices.voiceMailCreate(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.VOICE_MAIL_CREATE_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.VOICE_MAIL_CREATE_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.VOICE_MAIL_CREATE_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function deleteVoiceMail(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.DELETE_VOICE_MAIL_REQUEST,
            data: null
        }));
        clientsServices.deleteVoiceMail(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DELETE_VOICE_MAIL_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.DELETE_VOICE_MAIL_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.DELETE_VOICE_MAIL_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getAddressBookList(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.ADDRESS_BOOK_LIST_REQUEST,
            data: null
        }));
        clientsServices.getAddressBookList(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADDRESS_BOOK_LIST_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ADDRESS_BOOK_LIST_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ADDRESS_BOOK_LIST_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getCallLogs(data: any,value:any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.CALL_LOGS_REQUEST,
            data: null
        }));
        clientsServices.getCallLogs(data,value)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.CALL_LOGS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.CALL_LOGS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.CALL_LOGS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getSmsLogs(data: any,value:any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.SMS_LOGS_REQUEST,
            data: null
        }));
        clientsServices.getSmsLogs(data,value)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.SMS_LOGS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.SMS_LOGS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.SMS_LOGS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getOutboundProviders(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.OUT_BOUND_PROVIDERS_REQUEST,
            data: null
        }));
        clientsServices.getOutboundProviders(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.OUT_BOUND_PROVIDERS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.OUT_BOUND_PROVIDERS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.OUT_BOUND_PROVIDERS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}


function getAccountLogs(data: any,value:any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.ACCOUNT_LOGS_REQUEST,
            data: null
        }));
        clientsServices.getAccountLogs(data,value)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ACCOUNT_LOGS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ACCOUNT_LOGS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ACCOUNT_LOGS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getUsage(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.USAGE_REQUEST,
            data: null
        }));
        clientsServices.getUsage(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.USAGE_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.USAGE_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.USAGE_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getSipcredentials() {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.SIP_CREDENTIALS_REQUEST,
            data: null
        }));
        clientsServices.getSipcredentials()
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.SIP_CREDENTIALS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.SIP_CREDENTIALS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.SIP_CREDENTIALS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getActivityLogs(data: any,value:any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.ACTIVITY_LOGS_REQUEST,
            data: null
        }));
        clientsServices.getActivityLogs(data,value)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ACTIVITY_LOGS_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.ACTIVITY_LOGS_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.ACTIVITY_LOGS_FAILURE,
                        data: error.message
                    }));
                }
            );
    };

}

function getPaymentTransaction(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.GET_PAYMENT_TRANSACTION_REQUEST,
            data: null
        }));
        clientsServices.getPaymentTransaction(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.GET_PAYMENT_TRANSACTION_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.GET_PAYMENT_TRANSACTION_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.GET_PAYMENT_TRANSACTION_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function getAppDebugLogs(data: any,value:any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: clientsConstants.APP_DEBUG_REQUEST,
            data: null
        }));
        clientsServices.getAppDebugLogs(data,value)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: clientsConstants.APP_DEBUG_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: clientsConstants.APP_DEBUG_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: clientsConstants.APP_DEBUG_FAILURE,
                        data: error.message
                    }));
                }
            );
    };

}

function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}